module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[114]357.45904e0.woff2";